import { render, staticRenderFns } from "./EditDocLabOrga.vue?vue&type=template&id=1ede288e&scoped=true"
import script from "./EditDocLabOrga.vue?vue&type=script&lang=js"
export * from "./EditDocLabOrga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede288e",
  null
  
)

export default component.exports